import Button from './button';
import React from 'react';
import { withPrefix } from 'gatsby';

interface SectionPreviewPdfProps {
  title?: string;
  heading?: string;
  paragraph?: string;
  buttonLabel: string;
  filePath: string;
}

const SectionPreviewPdf: React.FC<SectionPreviewPdfProps> = ({
  title,
  heading,
  paragraph,
  buttonLabel,
  filePath
}) => (
  <section className="cta-section section-container section-light">
    <div className="container centered">
      <div className="section-headings-container" data-aos="fade-up">
        {title && <p className="text-uppercase text-small">{title}</p>}
        {heading && <h3>{heading}</h3>}
        {paragraph && <p>{paragraph}</p>}

        <Button
          type="primary"
          href={withPrefix(filePath)}
          hrefOptions={{ target: '_blank', rel: 'noopener noreferrer' }}
          label={buttonLabel}
        />
      </div>
    </div>
  </section>
);

export default SectionPreviewPdf;
